import { useNavigate, useParams } from "react-router-dom";
import { useGetCustom } from "@/api/customs.api";
import { useGetCustomPolicy } from "@/api/customPolicy.api";
import { CustomPolicyForm } from "@/components/backOffice/customs/customPolicies/customPolicyForm";
import { Button } from "@/components/ui/button";
import StyledSpinner from "@/components/styled/StyledSpinner";
import { useTranslation } from "react-i18next";

export const CustomPolicyPage = () => {
  const { customsId } = useParams<{ customsId: string }>();
  const { t } = useTranslation(["boCustoms", "common"]);
  const navigate = useNavigate();

  const {
    data: custom,
    isLoading: isLoadingCustom,
    isError: isErrorCustom,
  } = useGetCustom(customsId || "");
  const {
    data: policy,
    isLoading: isLoadingPolicy,
    isError: isErrorPolicy,
  } = useGetCustomPolicy(customsId || "");

  if (isLoadingCustom || isLoadingPolicy) {
    return <StyledSpinner />;
  }

  if (isErrorCustom || isErrorPolicy || !custom || !policy) {
    return (
      <div className="flex h-full w-full items-center justify-center p-8">
        <div className="flex flex-col items-center gap-4 text-center">
          <span className="text-lg font-semibold text-red-600">{t("policyPage.loadError")}</span>
          <span className="text-sm text-gray-500">{t("policyPage.loadErrorHelp")}</span>
          <Button onClick={() => navigate(-1)}>{t("common:actions.back")}</Button>
        </div>
      </div>
    );
  }

  return <CustomPolicyForm custom={custom} policy={policy} customsId={customsId || ""} />;
};
